import { Component, HostListener, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService, reRgType } from 'app/services/auth.service';
import { APIService } from 'app/services/api.service';
import { AppConfig } from "app/app.config";
import { sideMenuItemType } from "app/components/Controls/side-menu/side-menu.component";
import { LoaderService } from "app/services/loader.service";
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { NgClass } from '@angular/common';
import { SideMenuComponent } from '../../components/Controls/side-menu/side-menu.component';
import { PortfolioDetailsComponent } from '../../components/Controls/portfolio-details/portfolio-details.component';
import { DisclaimerComponent } from '../../components/Controls/disclaimer/disclaimer.component';

type planType = {
  title: string;
  id: string;
  PlanName: string;
  Registration: string;
  Currency: string;
  TargetNameID1: number;
  TargetNameID2: number;
  client: string;
};

type planSummaryType = {
  title: string;
  plans: planType[];
};

type internalPlanType = {
  id: string;
  items: Record<string, string>;
  title: string;
};

type planDataType = {
  id: string;
  Currency: string;
  PlanName?: string;
  title: string;
  TargetNameID1?: number;
  TargetNameID2?: number;
  AccountNumber?: number;
};

@Component({
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss'],
    imports: [MenuComponent, NgClass, SideMenuComponent, PortfolioDetailsComponent, DisclaimerComponent]
})

export class WelcomeComponent implements OnInit {
  private api = inject(APIService);
  private auth = inject(AuthenticationService);
  private router = inject(Router);
  private loaderService = inject(LoaderService);
  config = inject(AppConfig);
  route = inject(ActivatedRoute);

  public sideMenuItems: sideMenuItemType[] = [];
  public plan = '';
  public plans: planType[] = [];
  public planData?: planDataType;
  public valuationDate  = '';
  public isCollapse = false;
  public selectedReRg?: reRgType;
  public selectedPlan = '';
  public hasUSDPlan = false;
  public hasCADPlan = false;

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange() {
    this.isCollapse = false;
  }

  ngOnInit() {
    this.selectedReRg = this.auth.getCurrentReRg()!;

    this.route.params.subscribe(params => {
      this.setPlanData(params['id']);
    });

    this.loadWelcomePageData();
  }

  onValuationDateChange() {
    this.loadWelcomePageData();
  }

  loadWelcomePageData() {
    this.loaderService.display(true, 'welcome');
    this.valuationDate = this.auth.getCurrentValuationDate();
    if (!this.valuationDate) return;
    this.hasUSDPlan = false;
    this.hasCADPlan = false;
    this.plans = [];
    this.sideMenuItems = [];
    this.plan = '';
    this.planData = undefined;
    this.api.get<planSummaryType[]>(`${this.config.portfolio.portfolioPlansSummaryUrl}/${this.selectedReRg!.ReRgId}/${this.valuationDate}`).subscribe(
      data => {
        let subOverviewMenuItems: sideMenuItemType[] = [];
        const plans:  Record<string, internalPlanType> = {};
        for (let i = 0; i < data.length; i++) {
          const a = data[i];
          if (!a.plans || a.plans.length == 0) continue;
          //const plans: Record<string, internalPlanType> = {};
          a.plans.forEach(plan => {
            const client = plan.title.replace(' - ' + plan.PlanName,'');
            if (!plans[client]) {
              plans[client] = {
                id: plan.id,
                items: {},
                title: client,
              };
            }
            let planName = plan.PlanName;
            if (a.title == "US Dollar Accounts") {
              planName = plan.PlanName + ' (USD)';
              this.hasUSDPlan = true;
            }
            if (a.title == 'Canadian Dollar Accounts') {
              this.hasCADPlan = true;
            }
            plans[client].items[plan.Currency + ' - ' + plan.title] = planName;
          });
          this.plans.push(...a.plans);
        }

        if (this.hasCADPlan && this.hasUSDPlan) {
          subOverviewMenuItems = [{
            canActivate: false,
            id: '',
            opened: true,
            title: 'All Accounts',
            items: []
          },{
            canActivate: false,
            id: 'CAD',
            opened: true,
            title: 'All CAD Accounts',
            items: []
          },{
            canActivate: false,
            id: 'USD',
            opened: true,
            title: 'All USD Accounts',
            items: []
          }];
        } else if  ((this.hasCADPlan && !this.hasUSDPlan) || (!this.hasCADPlan && !this.hasUSDPlan)) {
          subOverviewMenuItems = [{
            canActivate: false,
            id: '',
            opened: true,
            title: 'All Accounts',
            items: []
          }];
        } else if  (this.hasUSDPlan && !this.hasCADPlan) {
          subOverviewMenuItems = [{
            canActivate: false,
            id: '',
            opened: true,
            title: 'All Accounts (USD)',
            items: []
          }];
        }


        this.sideMenuItems.push({
          canActivate: true,
          id: 'overview',
          opened: true,
          title: 'Overview',
          items: subOverviewMenuItems
        });

        Object.entries(plans).map(([,plan])=>{
          this.sideMenuItems.push({
            canActivate: true,
            id: plan.title,
            opened: true,
            title: plan.title,
            items:  Object.entries(plan.items).map(([id, plan]) => ({
              canActivate: false,
              id: id,
              items: [],
              opened: false,
              title: plan
            }))
          });
        });

        this.setPlanData(this.selectedPlan);
        this.loaderService.display(false, 'welcome');
      },
      () => {
        this.loaderService.display(false, 'welcome');
      }
    );
  }

  setPlanData(planParam : string) {
    this.selectedPlan = planParam;
    if (planParam) {
      if (planParam == "CAD") {
        this.plan = "CAD";
        this.planData = this.hasCADPlan ? { id: planParam, Currency: planParam, title: 'Overview - ' + this.plan, TargetNameID1: +this.selectedReRg!.ReRgId , PlanName: 'All CAD Accounts'} : undefined;
      } else if (planParam == "USD") {
        this.plan = 'USD';
        this.planData = this.hasUSDPlan ? { id: planParam, Currency: planParam, title: 'Overview - ' + this.plan, TargetNameID1: +this.selectedReRg!.ReRgId ,PlanName: 'All USD Accounts'} : undefined;
      } else if (planParam.match('^[0-9]+$')) {
        this.plan = planParam;
        for (let i = 0; i < this.plans.length; i++) {
          if (this.plans[i].id == this.plan)  {
            const plan = this.plans[i];
            this.planData = {
              Currency: plan.Currency,
              id: plan.id,
              PlanName: plan.PlanName,
              TargetNameID1: plan.TargetNameID1,
              TargetNameID2: plan.TargetNameID2,
              title: plan.title,
            };
            break;
          }
        }
      } else if (planParam.toLowerCase() === "pgf") {
        for (let i = 0; i < this.plans.length; i++) {
          if (this.plans[i].PlanName.toLowerCase() === "pgf")  {
            const plan = this.plans[i];
            this.plan = plan.Currency + ' - ' + plan.title;
            this.planData = {
              Currency: plan.Currency,
              id: plan.id,
              PlanName: plan.PlanName,
              TargetNameID1: plan.TargetNameID1,
              TargetNameID2: plan.TargetNameID2,
              title: plan.title,
            };
            break;
          }
        }
      } else {
        const currency = (planParam.indexOf('CAD -') === 0) ? 'CAD' : 'USD';
        const title = planParam.substr(6);
        for (let i = 0; i < this.plans.length; i++) {
          if (this.plans[i].Currency == currency && this.plans[i].title == title) {
            const plan = this.plans[i];
            this.plan = plan.Currency + ' - ' + plan.title;
            this.planData = {
              Currency: plan.Currency,
              id: plan.id,
              PlanName: plan.PlanName,
              TargetNameID1: plan.TargetNameID1,
              TargetNameID2: plan.TargetNameID2,
              title: plan.title,
            };
            break;
          }
        }
      }
      this.loaderService.navigateTo.next('plan');
    } else {
      this.plan = '';
      this.planData = undefined;
    }
  }

  changeAccount($event: string) {
    this.router.navigate(['/welcome/' + $event]);
  }

  changeGroup($event: string) {
    if ($event == "CAD Accounts" && this.plan != $event)
      this.router.navigate(['/welcome/CAD']);
    else if ($event == "USD Accounts"  && this.plan != $event)
      this.router.navigate(['/welcome/USD']);
  }
}